// JS dependencies
import "jquery";
import "@popperjs/core/dist/umd/popper";
import "bootstrap/dist/js/bootstrap.bundle";
import "select2";
import "@eonasdan/tempus-dominus/dist/js/tempus-dominus";
import "datatables.net-dt";
import "chart.js/auto";
import "admin-lte/dist/js/adminlte";
import "toastr";
import "summernote/dist/summernote-lite";
import "firebase/app";
import "firebase/messaging";

// Stylesheet dependencies
import "../../../public/cp/media/fonts/exo/exofont.css";
import "../../../public/cp/media/fonts/SourceSansPro/ssp.css";
import "admin-lte/dist/css/adminlte.css";
import "bootstrap/dist/css/bootstrap.css";
import "select2/dist/css/select2.css";
import "select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "toastr/build/toastr.css";
import "summernote/dist/summernote-lite.css";
